import React from 'react';
import Modal from 'react-modal';
import Button from '../controls/button';
import Loader from '../icons/tat/loader';

Modal.setAppElement('#root');

class GenericDialog extends React.Component {

  onClose = () => {
    if (this.props.isLoading) return;
    this.props.closeAction();
  }

  render() {
    return(
      <Modal
        isOpen={this.props.open}
        portalClassName="dialog generic-dialog"
        overlayClassName="overlay"
        className="content"
        >

        <div className="title">{this.props.title}</div>
        <div className="close" onClick={this.onClose}></div>

        <div className='message' style={{maxHeight: 300, overflow: 'auto'}}>{this.props.message}</div>

        <div className='bottom-container'>

          {
            this.props.cancelButton ?
            <Button
              disabled={this.props.isLoading}
              text={'Cancelar'}
              type={'secondary'}
              onClick = { () => {
                this.onClose();
              }}
            /> : <div/>
          }

          <div/>

          <Button
            disabled={this.props.isLoading}
            text={this.props.isLoading ? <Loader/> : 'Aceptar'}
            type={'primary'}
            onClick = { () => {
              if (this.props.isLoading) return;
              if (this.props.acceptAction) this.props.acceptAction();
            }}
          />

        </div>

      </Modal>
    );   
  }

}

export default GenericDialog;